import { useEffect } from "react";
import { useNavigationContext }from "shared/providers/NavigationProvider";

const useScrollToSection = () => {

    const { getStateFromNavigatedRoute } = useNavigationContext();

    const state = getStateFromNavigatedRoute();

    useEffect(() => {
        if (state?.scrollTo) {
            document.getElementById(state?.scrollTo)?.scrollIntoView({
                behavior: "smooth"
            });
        }
    }, [state?.scrollTo]);

    return null;

}

export default useScrollToSection;